import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import VueOffline from 'vue-offline'
import visibility from 'vue-visibility-change';
import numeral from 'numeral'

// Global assets
import IconBase from '@/components/IconBase'
import BrandSymbol from '@/components/icons/BrandSymbol'
import BrandLogo from '@/components/icons/BrandLogo'

import { defineCustomElements } from '@ionic/pwa-elements/loader';
// import { Plugins } from '@capacitor/core'

import VueGoogleCharts from 'vue-google-charts'


// PWA imports
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;

// const { SplashScreen } = Plugins
import { SplashScreen } from '@capacitor/splash-screen';
Vue.config.productionTip = false

Vue.component('IconBase', IconBase);
Vue.component('BrandSymbol', BrandSymbol);
Vue.component('BrandLogo', BrandLogo);

Vue.use(visibility);

Vue.use(Croppa, { componentName: 'cropper' });

import moment from './plugins/moment';
Vue.use(moment);

// TODO: REFACTOR NUMERALJS USAGE
numeral.register('locale', 'pt-br', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'mil',
    million: 'mi',
    billion: 'bi',
    trillion: 'tri'
  },
  ordinal: function (number) {
    return 'º';
  },
  currency: {
    symbol: 'R$'
  }
});

numeral.register('locale', 'es-ar', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'mil',
    million: 'millón',
    billion: 'mil millones',
    trillion: 'billón'
  },
  ordinal: function (number) {
    return 'º';
  },
  currency: {
    symbol: '$'
  }
});
Object.defineProperty(Vue.prototype, '$numeral', { value: numeral });

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import i18n from './i18n'
import VueNumber from 'vue-number-animation'
Vue.use(VueNumber)

Vue.use(VueOffline);

Vue.use(VueGoogleCharts);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  i18n,

  mounted () {
    SplashScreen.hide();
    defineCustomElements(window);
  }
}).$mount('#app')

